import React, { FunctionComponent } from "react";

import RecipesList from "../../RecipesList";
import { SanityRecipesRelated } from "../../../types/common";

type ExtraContentRecipesProps = {
  data: {
    title?: string | null;
    description?: string | null;
    cta?: string | null;
    recipes: SanityRecipesRelated;
  };
};

const ExtraContentRecipes: FunctionComponent<
ExtraContentRecipesProps
> = ({ data }) => {
  return (
    <RecipesList
        title={data.title}
        description={data.description}
        cta={data.cta}
        recipes={data.recipes}
      />
  );
};

export default ExtraContentRecipes;
